<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="md" :visible="modal.show" :data="model" @show="onShow"
                   :content-in-form="false" @hidden="onHidden" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" scrollable modal-class="mobile-full-screen">

      <template v-slot:modal-header>
        <div class="d-flex align-items-center">
          <h5 class="modal-title d-inline-block">
            {{ $t('Adjust Price') }}
          </h5>
        </div>
        <button type="button" :disabled="loading" @click="hideBulkPriceAdjustModal" aria-label="Close" class="close">×
        </button>
      </template>


      <div class="row">
        <div class="col-md-12">
          <b-form-group class="d-inline-block">
            <b-form-radio class="custom-control-inline" name="update_field" v-model="model.update_field"
                          value="start_price">{{ $t('Start Price') }}
            </b-form-radio>
            <b-form-radio class="custom-control-inline" name="update_field" v-model="model.update_field"
                          value="buy_now">{{ $t('Buy Now') }}
            </b-form-radio>
            <b-form-radio class="custom-control-inline" name="update_field" v-model="model.update_field"
                          value="reserve">{{ $t('Reserve') }}
            </b-form-radio>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <input-widget :model="model" attribute="against" value-field="value" display-field="${item.key}"
                        type="select2" :items="againstChoices"/>
        </div>
        <div class="col-md-6">
          <percentage-input-widget :model="model" attribute="percentage" v-if="model.against !== 'flat_price'" :rules="'min_value:0'"/>
          <input-widget :model="model" attribute="price" v-if="model.against === 'flat_price'" type="number"/>
        </div>
        <div class="col-md-6" v-if="!(model.update_field === 'reserve' && increment_calculation_source === 'reserve')" >
          <input-widget :model="model" attribute="match_increments" type="checkbox"/>
        </div>
        <div class="col-md-6"  v-if="model.against === 'low_estimate' && model.update_field !== 'reserve'">
          <input-widget :model="model" attribute="match_reserve" type="checkbox"/>
        </div>
      </div>

      <template v-slot:modal-footer>
        <template>
          <cancel-button @click="hideBulkPriceAdjustModal" :disabled="loading">
            {{ $t('Cancel') }}
          </cancel-button>
          <submit-button @click="handleSubmit(save)" :disabled="loading || shouldDisable()" :show-loader="loading">
            {{ $t('Submit') }}
          </submit-button>
        </template>
      </template>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import CancelButton from "../../../core/components/common/CancelButton";
  import SubmitButton from "../../../core/components/common/SubmitButton";
  import {createNamespacedHelpers} from "vuex";
  import BulkAdjustPriceModel from "@/modules/lots/bulk-adjust-price/BulkAdjustPriceModel.model";
  import i18n from "@/shared/i18n";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import PercentageInputWidget from "@/core/widgets/PercentageInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('lots');
  const {mapActions: reservationsMapActions} = createNamespacedHelpers('reservations');

  export default {
    name: "BulkAdjustPriceModal",
    components: {
      PercentageInputWidget,
      InputWidget,
      SubmitButton, CancelButton, ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new BulkAdjustPriceModel(),
        againstChoices: [
          {key: i18n.t('Reserve'), value: 'reserve'},
          {key: i18n.t('Low Estimate'), value: 'low_estimate'},
          {key: i18n.t('Flat Price'), value: 'flat_price'},
          {key: i18n.t('Start Price'), value: 'start_price'},
        ]
      }
    },
    computed: {
      ...mapState({
        modal: state => state.bulkAdjustPriceModal,
        reservations: state => state.bulkAdjustPriceModal.reservations,
        increment_calculation_source: state => state.bulkAdjustPriceModal.increment_calculation_source,
      }),
    },
    methods: {
      ...mapActions(['hideBulkPriceAdjustModal', 'bulkAdjustPrice']),
      ...reservationsMapActions(['getReservation']),
      onShow() {
        this.showConfirmation = true;
        this.model = new BulkAdjustPriceModel();
      },
      shouldDisable() {
        return !this.model.against;
      },
      onHidden() {
        this.hideBulkPriceAdjustModal();
      },
      async save() {
        this.loading = true;
        let modelResponse = await this.bulkAdjustPrice({...this.model, uuids: this.reservations});

        if (modelResponse.success) {
          this.loading = false
          this.showConfirmation = false;
          this.$toast('success', this.$t('Price Adjustment is started'))
          this.hideBulkPriceAdjustModal();
        } else {
          this.loading = false;
          if (modelResponse.toastError) {
            this.$errorDialog(modelResponse.toastError);
          } else if (modelResponse.body.non_field_errors) {
            this.$errorDialog(modelResponse.body.non_field_errors[0]);
          } else {
            if (modelResponse.body.dates) {
              for (let index in modelResponse.body.dates) {
                this.model.dates[index].setMultipleErrors(modelResponse.body.dates[index]);
              }
            } else {
              this.model.setMultipleErrors(modelResponse.body);
            }
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
